import { ApiFunusNotifications } from './types';
import axios from 'config/axios';

export const notifications: ApiFunusNotifications = {
  getNotifications: () => axios.get('/notifications')
};
